import { Link } from "react-router-dom";
import { Linkedin, Instagram, Facebook, Phone, Mail, MapPin } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export default function Footer() {
    return (
        <footer
            data-testid="main-footer"
            className="bg-[#112338] noise-overlay relative border-t border-white/10 px-4 sm:px-6 lg:px-8 pt-16 pb-8"
        >
            <div className="relative max-w-7xl mx-auto">
                <div className="grid md:grid-cols-4 gap-10">
                    <div className="md:col-span-2">
                        <img
                            src="/assets/logo-white-trim.png"
                            alt="Keypoteca"
                            className="h-10 w-auto"
                        />
                        <p className="mt-5 text-slate-400 max-w-sm leading-relaxed text-[15px]">
                            Tu hipoteca con seguridad y confianza, 100% online.
                            Estudio gratuito, asesoramiento personalizado y
                            gestión integral.
                        </p>
                        <div className="mt-6 flex gap-3">
                            {[
                                [Linkedin, "LinkedIn", "social-linkedin"],
                                [Instagram, "Instagram", "social-instagram"],
                                [Facebook, "Facebook", "social-facebook"],
                            ].map(([Icon, label, testid]) => (
                                <a
                                    key={label}
                                    data-testid={testid}
                                    href="#"
                                    aria-label={label}
                                    onClick={(e) => e.preventDefault()}
                                    className="flex items-center justify-center w-10 h-10 rounded-full border border-white/15 text-slate-300 hover:text-white hover:border-emerald-400 hover:bg-emerald-500/10 transition-[color,border-color,background-color] duration-200"
                                >
                                    <Icon size={17} />
                                </a>
                            ))}
                        </div>
                    </div>

                    <div>
                        <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-emerald-400">
                            Legal
                        </h4>
                        <ul className="mt-5 space-y-3 text-[15px]">
                            {[
                                ["Aviso legal", "/legal/aviso-legal", "footer-aviso-legal"],
                                ["Política de privacidad", "/legal/privacidad", "footer-política-de-privacidad"],
                                ["Política de cookies", "/legal/cookies", "footer-política-de-cookies"],
                            ].map(([l, to, testid]) => (
                                <li key={l}>
                                    <Link
                                        data-testid={testid}
                                        to={to}
                                        className="text-slate-400 hover:text-white transition-colors"
                                    >
                                        {l}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-emerald-400">
                            Contacto
                        </h4>
                        <ul className="mt-5 space-y-3 text-[15px]">
                            <li>
                                <a
                                    href="tel:+34622344472"
                                    className="flex items-center gap-2.5 text-slate-400 hover:text-white transition-colors"
                                >
                                    <Phone size={15} /> +34 622 344 472
                                </a>
                            </li>
                            <li>
                                <a
                                    href="mailto:hola@keypoteca.es"
                                    className="flex items-center gap-2.5 text-slate-400 hover:text-white transition-colors"
                                >
                                    <Mail size={15} /> hola@keypoteca.es
                                </a>
                            </li>
                            <li>
                                <span className="flex items-start gap-2.5 text-slate-400">
                                    <MapPin size={15} className="mt-1 shrink-0" />
                                    C/ Zurbano 83, 8 izda,
                                    <br />
                                    28003, Madrid
                                </span>
                            </li>
                        </ul>
                        <button
                            data-testid="footer-cta"
                            onClick={() => scrollToId("contacto")}
                            className="mt-6 rounded-full bg-emerald-500 hover:bg-emerald-400 text-[#0B1A2B] text-sm font-bold px-5 py-2.5 transition-colors duration-200"
                        >
                            Estudiar mi caso
                        </button>
                    </div>
                </div>

                <div className="mt-14 pt-7 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
                    <p className="text-xs text-slate-500">
                        © 2026 Keypoteca. Todos los derechos reservados.
                    </p>
                    <p className="font-mono text-xs text-slate-500 uppercase tracking-[0.2em]">
                        Seguridad y confianza, en línea
                    </p>
                </div>
            </div>
        </footer>
    );
}
